import { IResponse, httpGet, httpPost } from '../network';
import {
  DOCTORS_LIST_API,
  UNAPPROVED_DOCTORS_LIST_API,
  DOCTORS_SETTINGS_API,
  DOCTOR_RATING_REVIEWS_SUMMARY,
  DOCTOR_COMPLETE_DETAILS_API,
  GET_DOCTOR_INFO,
  SAVE_DOCTOR_INFO,
  GET_CONSULT_DATE,
  GET_CONSULT_DATES,
  UPDATE_EMERGENCY_BOOKING_CLOSE,
  DEFAULT_REMINDER_DAYS
} from '../../constants/api';
import {
  TDoctor,
  TDoctorSetting,
  TDoctorRatingSummary,
  TDoctorCompleteDetails,
  TDoctorBasicInfo,
  TDoctorSpecialization,
  TDoctorDiseaseTreatment,
  TDoctorSeoTabDetail,
  TDoctorAvailableConsultDate
} from '../../types/doctor';
export const fetchActiveDoctorsList=()=>{
  return httpGet<TDoctor[]>(DOCTORS_LIST_API)
}
export const fetchInActiveDoctors=(active_flag:number)=>{
 return httpGet<TDoctor[]>(UNAPPROVED_DOCTORS_LIST_API + `?active_flag=${active_flag}`)
}
export const fetchDoctorSettings=()=>{
  return httpGet<TDoctorSetting[]>(DOCTORS_SETTINGS_API)
}
export const fetchDoctorsRatingReviewsSummary = async (
  service_location_id: number = 0
) => {
  return httpGet<{ [key: string]: TDoctorRatingSummary }>(
    `${DOCTOR_RATING_REVIEWS_SUMMARY}?service_location_id=${service_location_id}`
  );
};
export const fetDoctorCompleteDetails = async (
  service_location_id: number,
  doctor_id: number
) => {
  return httpGet<TDoctorCompleteDetails>(
    DOCTOR_COMPLETE_DETAILS_API +
      `?doctor_id=${doctor_id}&service_location_id=${service_location_id}`
  );
};
export const fetchDoctorInfo=<T>(doctor_id:number,tab:string,service_loc_id:number=0):Promise<IResponse<T>>=>{
  return httpGet(`${GET_DOCTOR_INFO}?doctor_id=${doctor_id}&tab=${tab}${service_loc_id?'&service_loc_id='+service_loc_id:''}`);
}
export const fetchDoctorBasicInfo=(doctor_id:number):Promise<IResponse<TDoctorBasicInfo>>=>{
  return httpGet(`${GET_DOCTOR_INFO}?doctor_id=${doctor_id}&tab=basic_detail`)
}
export const fetchDoctorSpecialization=(doctor_id:number,group_category:string="DOCTOR"):Promise<IResponse<TDoctorSpecialization>>=>{
  return httpGet(`${GET_DOCTOR_INFO}?doctor_id=${doctor_id}&tab=specialization&group_category=${group_category}`)
}
export const fetchDiseaseTreatmentList=(doctor_id:number,service_loc_id:number):Promise<IResponse<TDoctorDiseaseTreatment>>=>{
  return httpGet(`${GET_DOCTOR_INFO}?doctor_id=${doctor_id}&service_loc_id=${service_loc_id}&tab=disease_treatments`)
}
export const fetchDoctorSeoDetails=(doctor_id:number):Promise<IResponse<TDoctorSeoTabDetail>>=>{
  return httpGet(`${GET_DOCTOR_INFO}?doctor_id=${doctor_id}&tab=seo_details`)
}
export const updateDoctorInfo= (doctor_id:number,service_loc_id:number=0,tab:string,params:any):Promise<IResponse<any>>=>{
  return httpPost(SAVE_DOCTOR_INFO,{...params,tab:tab,doctor_id:doctor_id,service_loc_id:service_loc_id});
}
export const fetchNextConsultDate=(service_loc_id:number)=>{
  return httpGet<{available_date:string,available_on:string}>(`${GET_CONSULT_DATE}?service_loc_id=${service_loc_id}`);
}
export const fetchNextConsultDates=(service_loc_id:number,count:number)=>{
  return httpGet<Array<TDoctorAvailableConsultDate>>(`${GET_CONSULT_DATES}?service_loc_id=${service_loc_id}&count=${count}`);
}
export const updateEmergencyBookingClose=(data:any)=>{
  return httpPost(UPDATE_EMERGENCY_BOOKING_CLOSE,data);
}
export const saveDefaultReminderDays=(data:any)=>{
  return httpPost(DEFAULT_REMINDER_DAYS,data);
}
export const getDefaultReminderDays=(service_loc_id:number)=>{
  return httpGet<{reminds_after:string}>(`${DEFAULT_REMINDER_DAYS}?service_loc_id=${service_loc_id}`);
}